export default __webpack_public_path__ + "static/media/6.6d126a67.png";